import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext } from 'react'
import GeneralContext from '../contexts/GeneralContext'
import { useNavigate } from 'react-router-dom'

function CommentsList() {
   const {currentComment, setCurrentComment, commentActivityID, setCommentActivityID, comments, setShowComments, get_userInfo,get_userInfoByID, setGuestPageData, setCurrentTab, setShowParticipants, get_activity, setComments} = useContext(GeneralContext)
   const navigator = useNavigate()

   const closeList = () => {
      setShowComments(false)
      setShowParticipants(false)
   }

   const redirectToPage = async (username) => {
      const data = await get_userInfo(username)
      console.log(data)
      setGuestPageData({
         name: data.attributes.name,
         description: data.attributes.description,
         imageSrc: data.attributes.profile_pic_src,
         username: data.attributes.username,
         id: data.id,
         tags: data.attributes.tags
      })
      if (data.id == sessionStorage.getItem('user')){
         setCurrentTab('Profile')
         navigator(`/main/profile`)
      }else{
         navigator(`/main/user/${username}`)
      }
      setShowParticipants(false)
      setShowComments(false)
   }
   const showCommentsFunc = async (activityID) => {
      const activity = await get_activity(activityID)
      const comments = activity.reactions
      setComments(comments)
   }

   const makeComment = async (comment) => {
      const userinfo = await get_userInfoByID(sessionStorage.getItem('user'))
      return fetch(
         "https://webdev.cse.buffalo.edu/hci/api/api/deekstra" + "/post-reactions",
         {
             method: "POST",
             headers: {
               'accept': '*/*',
               'Content-Type': 'application/json',
               'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
              },
              body: JSON.stringify({
                 postID: commentActivityID ,
                 reactorID: sessionStorage.getItem("user"),
                 name: currentComment,
                 value: 0,
                 attributes: {username: userinfo.attributes.username}
              })
         })
         .then(res => {
            console.log("Success")
            showCommentsFunc(commentActivityID)
            document.getElementById('comment_box').value='';

         })
         .catch(error => {
             console.error('Error:', error)
         })
    }

    const updateComment = (e) => {
        const text = e.target.value 
        setCurrentComment(text);
    }


   return (
      <div className="home_comments_list">
         <div className="comments_list_top">
            <FontAwesomeIcon
               icon={faXmark}
               className="comments_list_top_X"
               onClick={closeList}
            />
         </div>
         <div className="comments_list_title">Comments</div>
         <div className="comments_list_listFrame">
            <ul className="comments_list_listFrame_list">
            {comments.map((user) => {
                  return (
                     <li>
                        <div className="listFrame_list_commentCard">
                           <div className="commentCard_name " onClick={()=>{redirectToPage(user.attributes.username)}}>
                              {user.attributes.username}
                           </div>
                           <div className="commentCard_comment">
                              {user.name}   
                           </div>
                        </div>
                     </li>
                  )
               })}
            </ul>
         </div>
         <div className="comment_input_section">
             <label className="comment_label">Comment</label>
             <input type="text" id="comment_box" className="comment_input_box" placeholder="Comment" onChange= {updateComment}></input>
             <button type="button" className="comment_submit_bttn" onClick = {()=>{makeComment()}}>Submit</button>
         </div>
      </div>
   )
}

export default CommentsList


